import { render } from "./projects-view-table-page.vue?vue&type=template&id=f320e2aa&scoped=true"
import script from "./projects-view-table-page.vue?vue&type=script&lang=js"
export * from "./projects-view-table-page.vue?vue&type=script&lang=js"

import "./projects-view-table-page.vue?vue&type=style&index=0&id=f320e2aa&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f320e2aa"]])

export default __exports__